import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Gift, CheckCircle2, Loader2 } from "lucide-react";
import { http, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function LeadMagnetForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [profession, setProfession] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/leads", { email, name, profession, source: "lead_magnet" });
      setDone(true);
      toast.success("Guide envoyé", { description: "Vérifiez votre boîte mail (et les spams)." });
    } catch (err) {
      toast.error("Erreur", { description: formatApiErrorDetail(err.response?.data?.detail) });
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className="card-soft p-8 flex items-start gap-4" data-testid="lead-magnet-success">
        <div className="grid place-items-center h-12 w-12 rounded-2xl bg-emerald-500/10 text-emerald-600 shrink-0">
          <CheckCircle2 strokeWidth={1.75} />
        </div>
        <div>
          <h3 className="font-display font-semibold text-lg text-slate-900">Vos guides sont en route</h3>
          <p className="text-sm text-slate-600 mt-1">Ouvrez votre boîte mail — nous venons de vous envoyer les 7 guides en version française (PDF).</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={`card-soft ${compact ? "p-6" : "p-8"} relative overflow-hidden`} data-testid="lead-magnet-form" id="guide-gratuit">
      <div className="absolute -top-6 -right-6 h-32 w-32 rounded-full bg-brand-500/10 blur-2xl pointer-events-none" />
      <div className="flex items-center gap-3 mb-4">
        <div className="grid place-items-center h-11 w-11 rounded-2xl bg-brand-500 text-white shadow-sm">
          <Gift strokeWidth={1.75} />
        </div>
        <div>
          <div className="eyebrow">Guides gratuits</div>
          <h3 className="font-display font-bold text-xl text-slate-900 leading-tight">Recevez 7 guides de référence sur le développement de l'enfant</h3>
        </div>
      </div>
      <p className="text-sm text-slate-600 mb-5">Issus de centres de recherche de référence mondiaux : American Academy of Pediatrics, Harvard Center on the Developing Child, OMS, UNICEF.</p>
      <div className="grid gap-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Input data-testid="lead-name" placeholder="Prénom" value={name} onChange={(e) => setName(e.target.value)} />
          <Input data-testid="lead-profession" placeholder="Assmat, EJE, directrice…" value={profession} onChange={(e) => setProfession(e.target.value)} />
        </div>
        <Input data-testid="lead-email" type="email" required placeholder="votre@email.fr" value={email} onChange={(e) => setEmail(e.target.value)} />
        <button data-testid="lead-submit" type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-70">
          {loading ? <><Loader2 size={16} className="animate-spin" /> Envoi…</> : "Recevoir les guides gratuits"}
        </button>
        <p className="text-xs text-slate-500 text-center">Aucun spam. Désinscription en 1 clic.</p>
      </div>
    </form>
  );
}
